import React, { useState } from 'react'

import './index.css'

const FloatLabel = (props: any) => {
   const { children, label, value, required } = props
   const requiredMark = required ? <span className="text-danger">*</span> : null
   return (
      <div>
         {children}
         <label className="label">
            {requiredMark} {label}
         </label>
      </div>
   )
}

export default FloatLabel
